/**
 * Utility functions for managing onboarding-related localStorage
 */

/**
 * Clear all onboarding-related localStorage and sessionStorage
 */
export function clearOnboardingStorage() {
  localStorage.removeItem('onboarding-current-step');
  localStorage.removeItem('onboarding-form-data');
  localStorage.removeItem('onboarding-user-id');
  sessionStorage.removeItem('onboarding-energy-curve-shown');
  // Only log in development to reduce console noise
  if (process.env.NODE_ENV === 'development') {
    console.log('[onboarding-storage] Cleared all onboarding storage');
  }
}

/**
 * Save the current user ID to localStorage for tracking
 */
export function saveOnboardingUserId(userId: string) {
  localStorage.setItem('onboarding-user-id', userId);
}

/**
 * Get the saved user ID from localStorage
 */
export function getOnboardingUserId(): string | null {
  return localStorage.getItem('onboarding-user-id');
}

/**
 * Check if the current user ID matches the saved user ID
 */
export function isOnboardingUserIdMatch(currentUserId: string): boolean {
  const savedUserId = getOnboardingUserId();
  return savedUserId === currentUserId;
}

/**
 * Debug function to log current onboarding storage state
 */
export function debugOnboardingStorage() {
  console.log('[onboarding-storage] Debug info:', {
    currentStep: localStorage.getItem('onboarding-current-step'),
    formData: localStorage.getItem('onboarding-form-data'),
    userId: localStorage.getItem('onboarding-user-id'),
    energyCurveShown: sessionStorage.getItem('onboarding-energy-curve-shown'),
  });
}

/**
 * Force clear onboarding storage and log debug info
 */
export function forceClearOnboardingStorage() {
  console.log('[onboarding-storage] Force clearing storage...');
  debugOnboardingStorage();
  clearOnboardingStorage();
  console.log('[onboarding-storage] After clearing:');
  debugOnboardingStorage();
} 